// Put your application javascript here
const dropdownLinks = [].slice.call(document.querySelectorAll('.top-bar__link--has-dropdown'));
dropdownLinks.forEach((elm) => {
	elm.addEventListener('mouseover', () => {
		elm.closest('.top-bar').classList.add('top-bar--dropdown');
	});
	elm.addEventListener('mouseout', () => {
		elm.closest('.top-bar').classList.remove('top-bar--dropdown');
	});
});

if(window.innerWidth > 880) {
	const pageContent = document.querySelector('.page-content');
	if(pageContent) {
		const logo = document.querySelector('.top-bar__logo-main img');
		const adjustContent = () => {
			pageContent.style.marginLeft = logo.getBoundingClientRect().x + 'px';
		};

		window.addEventListener('load', adjustContent);
		window.addEventListener('resize', adjustContent);
		adjustContent();
	}
}